export default "__VITE_ASSET__C0cCR9ac__"